var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"dashboard"}},[(_vm.tokenList != null && _vm.tokenList.length === 0)?_c('NoTokens'):_c('TokenDetails',{attrs:{"token":_vm.activeToken},on:{"update:token":function($event){_vm.activeToken=$event}}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }